/*
status = 0 -> data hasn't been loaded
status = 1 -> data is loading
status = 2 -> data is loaded successfully
status = 3 -> data is loaded unsuccessfully
*/

import VehicleAPI from '../api/vehicle.js';
import ContractorAPI from "../api/contractor";

export const vehicles = {
    namespaced: true,

    state: {
        vehicles: [],
        vehiclesLoadStatus: 0,

        formVisible: false,
        form: {},

        vehicleUpdateStatus: 0,

        vehicleTypes: [
            { key: 'truck', label: 'TRUCK' },
            { key: 'trailer', label: 'TRAILER' },
            { key: 'car', label: 'CAR' },
            { key: 'van', label: 'VAN' },
            { key: 'motorcycle', label: 'MOTORCYCLE' },
        ],
        vehicleBodyStyles: [
            { key: 'curtain sider', label: 'Curtain Sider' },
            { key: 'flat deck', label: 'Flat Deck' },
            { key: 'hard body', label: 'Hard Body' },
            { key: 'furniture', label: 'Furniture' },
            { key: 'swing lift', label: 'Swing Lift' },
            { key: 'skeletal', label: 'Skeletal' },
        ],
        vehicleSpecialEquipments: [
            { key: 'tail lift', label: 'Tail Lift' },
            { key: 'hiab', label: 'Hiab' },
            { key: 'moffett forklift', label: 'Moffett Forklift' },
        ]
    },

    actions: {
        loadVehicles({ commit }) {
            commit('setVehiclesLoadStatus', 1);
            VehicleAPI.getVehicles()
                .then(response => {
                    commit('setVehicles', response.data.data);
                    commit('setVehiclesLoadStatus', 2);
                })
                .catch(() => {
                    commit('setVehicles', []);
                    commit('setVehiclesLoadStatus', 3);
                });
        },
        updateVehicle({ commit, dispatch }, data) {
            commit('setVehicleUpdateStatus', 1);

            VehicleAPI.putVehicle(data)
                .then(response => {
                    commit('setVehicleUpdateStatus', 2);
                    commit('setFormVisible', false);
                    dispatch('loadVehicles');
                })
                .catch(() => {
                    commit('setVehicleUpdateStatus', 3);
                });
        },
        closeForm({ commit }) {
            commit('setFormVisible', false);
        },
        openForm({ commit }, { vehicle }) {
            commit('setFormVisible', true);
            commit('setForm', vehicle);
        }
    },

    mutations: {
        setVehicles(state, rawVehicles) {
            state.vehicles = rawVehicles.map(rawVehicle => {
                return rawVehicle
            });
        },
        setVehiclesLoadStatus(state, status) {
            state.vehiclesLoadStatus = status;
        },
        setFormVisible(state, bool) {
            state.formVisible = bool;
        },
        setForm(state, vehicle) {
            state.form = vehicle;
        },
        setVehicleUpdateStatus(state, status) {
            state.vehicleUpdateStatus = status;
        }
    },

    getters: {
    },
};

/**
 * Helpers
 */

